import { render, staticRenderFns } from "./UnAccept.vue?vue&type=template&id=4a49fc32&scoped=true&"
import script from "./UnAccept.vue?vue&type=script&lang=js&"
export * from "./UnAccept.vue?vue&type=script&lang=js&"
import style0 from "./UnAccept.vue?vue&type=style&index=0&id=4a49fc32&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a49fc32",
  null
  
)

export default component.exports